// extracted by mini-css-extract-plugin
export default {"root":"CustomFormikSelect_root__nQ9U7","errorMessage":"CustomFormikSelect_errorMessage__LuCYd"};